import { type SyntheticEvent, useCallback } from 'react'

import { useSetActiveConversationId } from 'hooks/useSetActiveConversationId'
import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { useSetCreateConversationStatus } from 'stores/useCreateConversationStatusStore'
import { useClosePanel } from 'stores/usePanelsStateStore'
import { useClearPendingUserMessage } from 'stores/usePendingUserMessageStateStore'
import { useIsXlOrAbove } from 'stores/useScreenSizeStore'
import { isUserInputEvent } from 'utils/isUserInput'

export const useStartNewConversation = <T>() => {
  const triggerEvent = useTriggerEvent()

  const isXlOrAbove = useIsXlOrAbove()

  const closePanel = useClosePanel()

  const { setActiveConversationId } = useSetActiveConversationId()

  const clearPendingUserMessage = useClearPendingUserMessage()

  const setCreateConversationStatus = useSetCreateConversationStatus()

  const handleClickNewConversation = useCallback(
    (event: SyntheticEvent<T>) => {
      triggerEvent({
        name: 'kai_new_conversation_button_clicked',
      })

      if (isUserInputEvent(event) && (event.metaKey || event.ctrlKey)) return

      clearPendingUserMessage()

      setCreateConversationStatus('idle')

      setActiveConversationId()

      if (!isXlOrAbove) closePanel('conversations_menu')
    },
    [
      clearPendingUserMessage,
      closePanel,
      isXlOrAbove,
      setActiveConversationId,
      setCreateConversationStatus,
      triggerEvent,
    ],
  )

  return {
    handleClickNewConversation,
  }
}
